var map = {
	"./10_c.png": 1125,
	"./10_d.png": 3399,
	"./10_h.png": 5282,
	"./10_s.png": 3110,
	"./11_c.png": 6303,
	"./11_d.png": 6069,
	"./11_h.png": 1382,
	"./11_s.png": 8603,
	"./12_c.png": 6367,
	"./12_d.png": 9324,
	"./12_h.png": 8718,
	"./12_s.png": 7746,
	"./13_c.png": 5524,
	"./13_d.png": 9098,
	"./13_h.png": 884,
	"./13_s.png": 1941,
	"./1_c.png": 3330,
	"./1_d.png": 157,
	"./1_h.png": 9385,
	"./1_s.png": 4397,
	"./2_c.png": 5927,
	"./2_d.png": 1293,
	"./2_h.png": 3917,
	"./2_s.png": 289,
	"./3_c.png": 4152,
	"./3_d.png": 3169,
	"./3_h.png": 9651,
	"./3_s.png": 722,
	"./4_c.png": 8546,
	"./4_d.png": 8231,
	"./4_h.png": 8466,
	"./4_s.png": 2717,
	"./5_c.png": 8967,
	"./5_d.png": 2033,
	"./5_h.png": 1895,
	"./5_s.png": 3617,
	"./6_c.png": 4233,
	"./6_d.png": 6851,
	"./6_h.png": 6391,
	"./6_s.png": 1880,
	"./7_c.png": 2039,
	"./7_d.png": 715,
	"./7_h.png": 7990,
	"./7_s.png": 5620,
	"./8_c.png": 6705,
	"./8_d.png": 3575,
	"./8_h.png": 8870,
	"./8_s.png": 1682,
	"./9_c.png": 4671,
	"./9_d.png": 8143,
	"./9_h.png": 3093,
	"./9_s.png": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4136;